import { render, staticRenderFns } from "./AreaFilter.vue?vue&type=template&id=4fee4ed0"
import script from "./AreaFilter.ts?vue&type=script&lang=ts&external"
export * from "./AreaFilter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports